import { render, staticRenderFns } from "./CtaTile.vue?vue&type=template&id=6a5930d4&scoped=true&lang=pug&"
import script from "./CtaTile.vue?vue&type=script&lang=js&"
export * from "./CtaTile.vue?vue&type=script&lang=js&"
import style0 from "./CtaTile.vue?vue&type=style&index=0&id=6a5930d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5930d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a5930d4')) {
      api.createRecord('6a5930d4', component.options)
    } else {
      api.reload('6a5930d4', component.options)
    }
    module.hot.accept("./CtaTile.vue?vue&type=template&id=6a5930d4&scoped=true&lang=pug&", function () {
      api.rerender('6a5930d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CtaTile.vue"
export default component.exports